import React from 'react';
import type { MenuSourcePage } from '../../data/menuSourcePages';
import SmartImagePreview from '../shared/SmartImagePreview';

interface SourceMenuGalleryProps {
  pages: MenuSourcePage[];
}

const SourceMenuGallery: React.FC<SourceMenuGalleryProps> = ({ pages }) => (
  <div className="grid gap-4 lg:grid-cols-2">
    {pages.map((page) => (
      <div key={page.id} className="arab-panel overflow-hidden p-4">
        <SmartImagePreview src={page.imageUrl} alt={page.title} className="h-[420px]" fit="contain" />
        <div className="mt-4">
          <div className="text-lg font-semibold text-white">{page.title}</div>
          <div className="mt-3 flex flex-wrap gap-2">
            {page.sections.map((section) => (
              <span key={section} className="arab-chip">
                {section}
              </span>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default SourceMenuGallery;
